import { render, staticRenderFns } from "./partnerProfit.vue?vue&type=template&id=266317f6"
import script from "./partnerProfit.vue?vue&type=script&lang=js"
export * from "./partnerProfit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports